"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b, _c;
var moment = require("moment");
var momentDurationFormatSetup = require('moment-duration-format');
momentDurationFormatSetup(moment);
var athlinks_results_model_1 = require("athlinks-results-model");
var _1 = require(".");
var lodash_1 = require("lodash");
var timeCommon_1 = require("./timeCommon");
var __1 = require("..");
function buildShortLabelMap(unit) {
    return {
        singular: unit,
        plural: unit
    };
}
function buildTimeLabelMap() {
    var map = {};
    map[athlinks_results_model_1.TimeUnit.MILLI_SECONDS] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.TimeUnit.MILLI_SECONDS),
        'standard': {
            singular: 'millisecond',
            plural: 'milliseconds'
        }
    }); };
    map[athlinks_results_model_1.TimeUnit.SECONDS] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.TimeUnit.SECONDS),
        'standard': {
            singular: 'second',
            plural: 'seconds'
        }
    }); };
    map[athlinks_results_model_1.TimeUnit.MINUTES] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.TimeUnit.MINUTES),
        'standard': {
            singular: 'minute',
            plural: 'minutes'
        }
    }); };
    map[athlinks_results_model_1.TimeUnit.HOURS] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.TimeUnit.HOURS),
        'standard': {
            singular: 'hour',
            plural: 'hours'
        }
    }); };
    // The default case
    map['undefined'] = function () { return ({
        'short': buildShortLabelMap(athlinks_results_model_1.TimeUnit.MILLI_SECONDS),
        'standard': {
            singular: 'millisecond',
            plural: 'milliseconds'
        }
    }); };
    return map;
}
var timeLabelLongMap = buildTimeLabelMap();
function findLabel(magnitude, unit, verbosity) {
    var plurality = (_1.isPlural(magnitude)) ? _1.LabelPlurality.PLURAL : _1.LabelPlurality.SINGULAR;
    return timeLabelLongMap[unit]()[verbosity][plurality];
}
exports.findLabel = findLabel;
var timeDefaultTemplateMap = (_a = {},
    _a['ms'] = function () { return timeCommon_1.DefaultTimeTemplates.Millis; },
    _a['s'] = function () { return timeCommon_1.DefaultTimeTemplates.MinutesSeconds; },
    _a['m'] = function () { return timeCommon_1.DefaultTimeTemplates.HoursMinutesSeconds; },
    _a['h'] = function () { return timeCommon_1.DefaultTimeTemplates.HoursMinutesSeconds; },
    _a);
// This is here just for type completeness,
// it should never do much in terms of precision
var msToMs = function (ms, precision, unitType) {
    return _1.makePrecise(ms, precision, unitType);
};
var msToSeconds = function (ms, precision, unitType) {
    return _1.makePrecise(ms / 1000, precision, unitType);
};
var msToMinutes = function (ms, precision, unitType) {
    return _1.makePrecise(msToSeconds(ms, precision, unitType) / 60, precision, unitType);
};
var msToHours = function (ms, precision, unitType) {
    return _1.makePrecise(msToMinutes(ms, precision, unitType) / 60, precision, unitType);
};
var rawTimeConverter = (_b = {},
    _b['ms'] = msToMs,
    _b['s'] = msToSeconds,
    _b['m'] = msToMinutes,
    _b['h'] = msToHours,
    _b);
/**
 * This is used in pace calculations only
 *
 * @param time TimeUnit in normalized format
 * @param precision Precision
 */
function convertTimeValue(time, precision) {
    var timeInMillis = time.timeInMillis, timeUnit = time.timeUnit;
    return rawTimeConverter[timeUnit](timeInMillis, precision, timeUnit);
}
exports.convertTimeValue = convertTimeValue;
var defaultTimeTemplateLabelMap = (_c = {},
    _c[timeCommon_1.DefaultTimeTemplates.Millis] = function () { return athlinks_results_model_1.TimeUnit.MILLI_SECONDS; },
    _c[timeCommon_1.DefaultTimeTemplates.SecondsMillis] = function () { return athlinks_results_model_1.TimeUnit.SECONDS; },
    _c[timeCommon_1.DefaultTimeTemplates.MinutesSeconds] = function () { return athlinks_results_model_1.TimeUnit.MINUTES; },
    _c[timeCommon_1.DefaultTimeTemplates.HoursMinutesSeconds] = function () { return athlinks_results_model_1.TimeUnit.HOURS; },
    _c);
function mapDefaultTimeTemplateLabel(timeUnit, template) {
    var temp = lodash_1.isFunction(template) ? template() : template;
    var mapper = defaultTimeTemplateLabelMap[temp];
    return mapper ? mapper() : timeUnit;
}
exports.mapDefaultTimeTemplateLabel = mapDefaultTimeTemplateLabel;
function roundUpToTheNearestSecond(timeInMillis) {
    var delta = timeInMillis % 1000;
    return delta ? timeInMillis - delta + 1000 : timeInMillis;
}
exports.roundUpToTheNearestSecond = roundUpToTheNearestSecond;
function convertTime(time, args) {
    if (args === void 0) { args = {}; }
    var rawMillis = time.timeInMillis, timeUnit = time.timeUnit;
    var template = args.template, _a = args.verbosity, verbosity = _a === void 0 ? _1.LabelVerbosity.SHORT : _a, _b = args.capitalize, capitalize = _b === void 0 ? false : _b, _c = args.roundUpSeconds, roundUpSeconds = _c === void 0 ? true : _c;
    var actualTemplate = undefined;
    if (rawMillis < 0) {
        __1.UnitLog.warn("Negative time value found (" + rawMillis + "), returning empty.");
        return {
            value: '',
            label: ''
        };
    }
    var timeInMillis = roundUpSeconds ?
        roundUpToTheNearestSecond(rawMillis) : rawMillis;
    try {
        var millis = moment.duration(timeInMillis, 'milliseconds');
        actualTemplate =
            (template) ? template : timeDefaultTemplateMap[timeUnit]();
        // seconds are a special case
        var value = lodash_1.padStart(millis.format(actualTemplate, {}), 4, '0:0');
        var timeUnitForLabel = mapDefaultTimeTemplateLabel(timeUnit, template);
        var label = findLabel(timeInMillis, timeUnitForLabel, verbosity);
        return {
            value: value,
            label: (capitalize) ? lodash_1.capitalize(label) : label
        };
    }
    catch (_d) {
        __1.UnitLog.warn("Could not convert time " + timeInMillis + " to unit type '" + timeUnit + "'" +
            ("" + (actualTemplate ? " with format '" + actualTemplate + "'." : '.')));
        return {
            value: timeInMillis.toString(),
            label: athlinks_results_model_1.TimeUnit.MILLI_SECONDS
        };
    }
}
exports.convertTime = convertTime;
//# sourceMappingURL=time.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/lib-athlinks-units/dist/units/time.js
 ** module id = 1086
 ** module chunks = 0
 **/